"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringLengthRule = void 0;
var validation_rule_1 = require("./validation-rule");
/**
 * A rule that validates that validates that the length of a string property is within a specific range
 */
var StringLengthRule = /** @class */ (function (_super) {
    __extends(StringLengthRule, _super);
    /**
     * Creates a rule that validates that the length of a string property is within a specific range
     * @param rootType The model type the rule is for
     * @param options The options for the rule
     */
    function StringLengthRule(rootType, options) {
        var _this = this;
        // ensure the rule name is specified
        options.name = options.name || "StringLength";
        options.message = function () {
            var range = {};
            if (options.min && options.min instanceof Function) {
                try {
                    range.min = options.min.call(this);
                }
                catch (e) {
                    // Silently ignore min errors
                }
            }
            if (options.max && options.max instanceof Function) {
                try {
                    range.max = options.max.call(this);
                }
                catch (e) {
                    // Silently ignore max errors
                }
            }
            var val = options.property.value(this);
            if (val == null || typeof val !== "string" || val.length === 0) {
                return null;
            }
            if ((range.min == null || val.length >= range.min) && (range.max == null || val.length <= range.max)) {
                // Value is within range
                return null;
            }
            if (range.min != null && range.max != null)
                return rootType.model.getResource("string-length-between").replace("{min}", range.min.toString()).replace("{max}", range.max.toString());
            if (range.min != null)
                return rootType.model.getResource("string-length-at-least").replace("{min}", range.min.toString());
            else
                return rootType.model.getResource("string-length-at-most").replace("{max}", range.max.toString());
        };
        // call the base type constructor
        _this = _super.call(this, rootType, options) || this;
        return _this;
    }
    // get the string representation of the rule
    StringLengthRule.prototype.toString = function () {
        return this.property.containingType.fullName + "." + this.property.name + " string length, min: , max: ";
    };
    return StringLengthRule;
}(validation_rule_1.ValidationRule));
exports.StringLengthRule = StringLengthRule;
